module.exports = __webpack_public_path__ + "assets/img/swiper-1.9ad3cfef.jpg";